export default __webpack_public_path__ + "static/media/NIAS0360.34I-32914_-19517_0.002eb62b.jpg";